<style lang="scss">
	#downitem {
		// text-align: center;
		padding-top: 5rem;

		.btn {
			color: #0C8B96;
			position: absolute;
			// right: 30.5vw;
			top: 6.1rem;
			font-size: .8rem !important;
			z-index: 100;
			cursor: pointer;
		}

		.cbox {
			width: 1rem;
			height: 1rem;
			display: inline-block;
			top: .1rem;
			position: relative;
		}

		.test {
			// width: 90%;
			// margin: 4rem auto;
			display: inline-block;
			// box-shadow: -4px 3px 3px #eaeaea;
			// position: relative;
			// left: 30vw;
		}

		.title-down {
			text-align: left;
			border: 1px solid #d8d8d8;
			border-bottom: none;
			position: relative;
		}

		.title-down>div {
			display: inline-block;
			font-size: 1rem;
			overflow: hidden;
		}

		.table-td {
			display: inline-block;
			border-color: #d8d8d8 !important;
			border-left: 1px solid;
			border-top: 1px solid;
			font-size: .8rem;
			padding: .2rem;
			text-align: center;
			vertical-align: top;
		}

		.down-big {
			width: 8rem;
			height: 3.8rem;
		}

		.down-small {
			width: 3.8rem;
			height: 3.8rem;
			padding: 0.7rem;
		}

		.left-list {
			border-right: 1px solid;
		}

		.yel-yal {
			background-color: #48c8d4;
			color: #fff;
			padding: .7rem;
		}

		.td-bigtr {
			line-height: 2.8rem;
			font-weight: 700;
			color: #000;
		}
	}
</style>
<template>
	<div id='downitem'>
		<div class='btn' @click='toImage' :style='{right:stylefn}'>
			<img :src="require('@/image/simu/word.png')" alt=""
			 style="width: 1rem;margin-top: -0.2rem;">
			導出
		</div>
		<div style='text-align: center;'>
		<div id="pdfDom" class='test jy-page container' ref="imageDom">
			<div class='title-down' style="padding: 1rem;">
				<!-- <div>
					<div class='cbox' style="background: #369bf7;"></div>
					招股期
				</div>
				<div>
					<div class='cbox' style="background: #bdfbf6;"></div>
					資金凍結期
				</div>
				<div>
					<div class='cbox' style="background: #da3847;"></div>
					公佈中籤日
				</div>
				<div>
					<div class='cbox' style="background: #faac40;"></div>
					上市日
				</div> -->
				<img :src="require('@/image/simu/titleimg.png')" alt="" style="width:28rem">
				
			</div>

			<div>
				<div class='table-td down-big td-bigtr'>
					新股名稱
				</div>
				<div class='table-td down-big td-bigtr'>
					股票代碼
				</div>
				<div class='table-td down-small yel-yal' v-for='(val,index) in tabledata.day'
					:class='index == tabledata.day.length-1?"left-list":""'>
					{{val}}
					<br>
					{{tabledata.week[index]}}
				</div>
			</div>
			<div v-for="(item,indx) in tabledata.stockcodes" style=''>
				<div class='table-td' v-for='(vals,inds) in item' :class='inds>1?"down-small":"down-big"' :style='{"borderRight":(inds == item.length - 1)?"1px solid":""
				,borderBottom:(indx == tabledata.stockcodes.length - 1)?"1px solid":"",
				backgroundColor:lisarr[vals.color],
				color:vals.color?"#fff":"#000",
				lineHeight:(vals.color==0&&vals.word.length<10)?"2.8rem":vals.color==4?"2rem":"",
				fontSize:inds==0||inds==1?".7rem":"",
				padding:(inds==0&&vals.word.length>=10)?"1rem 0":""}'>
					{{vals.word}}
				</div>
			</div>
		</div>
		</div>
		<!-- <img src="./tr.png" alt=""> -->
	</div>
</template>
<script>
	import App from '@/assets/app.js';
	import html2canvas from 'html2canvas';

	export default {
		props: ['isopen'],
		data() {
			return {
				loading: false,
				lisarr: ['', '#61a4ff', '#c5acff', '#df3e3e', '#ffad2d'],
				tabledata: {},
				stylefn:''
			};
		},
		mounted() {
			this.handleOk()
			// html2canvas(document.body).then(function(canvas) {
			//     document.body.appendChild(canvas);
			// });
		},
		methods: {
			
			toImage() {
				html2canvas(this.$refs.imageDom, {
					backgroundColor: '#ffffff'
				}).then(canvas => {
					var imgData = canvas.toDataURL("image/jpeg");
					// console.log(this.$refs.imgData)
					this.fileDownload(imgData);
				})
			},
			fileDownload(downloadUrl) {
				console.log(downloadUrl)
				let aLink = document.createElement("a");
				aLink.style.display = "none";
				aLink.href = downloadUrl;
				aLink.download = "圖片.png";
				// 触发点击-然后移除
				document.body.appendChild(aLink);
				aLink.click();
				document.body.removeChild(aLink);
			},
			handleOk(ruleForm) {
				var query = window.location.href;
				var strlist = query.split("=")[1].split(',');
				this.$ajax({
					method: 'post',
					url: this.$api.getstockstables,
					data: {
						"idList": strlist
					} //,4686[4776,4698,4684,4990]
				}).then(res => {
					console.log(res.data)
					if (res.data.qmiscode == 1000) {
						// App.oTool.successT();
						this.tabledata = res.data
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
					
					setTimeout(()=>{
						console.log(this.$refs.imageDom.offsetWidth)
						this.stylefn = (document.body.clientWidth - this.$refs.imageDom.offsetWidth)/2 + 20 + 'px'
					},100)
				})
			}
		},
	};
</script>
